// third party libraries
import React from 'react';
import { Redirect } from 'react-router';

// local components and data
import { sessionClear } from '@sgp/lib/util/utilities';
import { isSessionActive } from '@sgp/cognito';
import { isSsoSessionActive } from '@sgp/sso';
import { AUTO_LOGOUT_TIMEOUT } from '@sgp/data/constants';

const withAuthenticateRouting = ProtectedComponent => props => {
  const startTime = +localStorage.getItem('startTime');
  const timeLimit = 1000 * 60 * AUTO_LOGOUT_TIMEOUT;

  // Grant access only when:
  // 1. a valid (unexpired) Cognito token session OR an active SSO session exists
  // 2. the 30-minute activity window has not been exceeded
  if ((isSessionActive() || isSsoSessionActive()) && (startTime + timeLimit) > new Date().getTime()) {
    return <ProtectedComponent {...props} />;
  } else {
    // remove all stored sessions
    sessionClear();
    return <Redirect to="/loginchoice" />;
  }
};

export default withAuthenticateRouting;